/**
 * Results XLSX Generator
 * Generate downloadable XLSX files with email credentials results
 */
import * as XLSX from "xlsx";
/**
 * Generate XLSX blob from results
 */
export function generateResultsBlob(results) {
    // Create worksheet data
    const worksheetData = [
        // Header row
        ["Row Number", "V5UserId", "IdentityId", "Display Name", "UPN", "Status", "Error/Skip Reason"],
    ];
    // Add data rows
    results.records.forEach((record) => {
        worksheetData.push([
            record.rowNumber,
            record.v5UserId || "",
            record.identityId || "",
            record.displayName || "",
            record.upn || "",
            record.status,
            record.error || record.skipReason || "",
        ]);
    });
    // Create workbook
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    // Set column widths
    worksheet["!cols"] = [
        { wch: 12 }, // Row Number
        { wch: 18 }, // V5UserId
        { wch: 38 }, // IdentityId
        { wch: 25 }, // Display Name
        { wch: 30 }, // UPN
        { wch: 10 }, // Status
        { wch: 40 }, // Error/Skip Reason
    ];
    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Results");
    // Generate buffer
    const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    // Create blob
    return new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
}
/**
 * Download results as XLSX file
 */
export function downloadResultsXlsx(results) {
    const blob = generateResultsBlob(results);
    // Generate filename with timestamp
    const timestamp = new Date().toISOString().replace(/[:.]/g, "-").split("T")[0];
    const filename = `EmailCredentials_Results_${timestamp}.xlsx`;
    // Create download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
/**
 * Get status summary text
 */
export function getStatusSummary(results) {
    const parts = [];
    if (results.sentCount > 0) {
        parts.push(`${results.sentCount} sent`);
    }
    if (results.skippedCount > 0) {
        parts.push(`${results.skippedCount} skipped`);
    }
    if (results.failedCount > 0) {
        parts.push(`${results.failedCount} failed`);
    }
    return parts.join(", ");
}
/**
 * Check if there are any errors in the results
 */
export function hasErrors(results) {
    return results.failedCount > 0;
}
/**
 * Check if there are any skipped users in the results
 */
export function hasSkipped(results) {
    return results.skippedCount > 0;
}
/**
 * Get records by status
 */
export function getRecordsByStatus(records, status) {
    return records.filter((r) => r.status === status);
}
